import styled from 'styled-components';
import { Input } from '../index';

export const H30pxInput = styled(Input)`
  input {
    height: 30px;
  }
`;
